<template>
    <apexchart
      type="bar"
      height="90%"
      width="100%"
      :options="this.options"
      :series="getSeries"
    ></apexchart>
</template>

<script>
export default {
  name: "apexchartVerticalBar",
  props: {
    data: {
      type: Object
    },
    loading: {
      type: Boolean
    }
  },
  data() {
    return {
      options: {
        chart: {
          type: "bar",
          stacked: false,
          toolbar: {
            show: true
          }
        },
        colors: ["#F56618", "#eae123", "#07b701"],
        plotOptions: {
          bar: {
            borderRadius: 6,
            horizontal: false,
            dataLabels: {
              position: "center",
              style: {
                colors: ["#000"],
                fontFamily: "sans-serif",
                fontSize: "20"
              }
            },
            columnWidth: "85%",
            barHeight: "80%"
          }
        },
        xaxis: {
          categories: [
            "0 a 14",
            "15 a 20",
            "21 a 30",
            "31 a 40",
            "41 a 50",
            "51 a 60",
            "61 ou mais",
            "Não informado"
        ]
        },
        legend: {
          show: true,
          onItemHover: {
            highlightDataSeries: true
          },
          onItemClick: {
            toggleDataSeries: false
          }
        },
        dataLabels: {
          enabled: true,

          style: {
            colors: ["#fff"],
            fontFamily: "sans-serif"
          },
          formatter: function(val, opt) {
            return val;
          },

          dropShadow: {
            enabled: true
          }
        },
        yaxis: {
          labels: {
            show: true
          }
        },
        tooltip: {
          enabled: true
        },
        responsive: [
          {
            breakpoint: 1000,
            options: {
              chart: {
                type: "bar",
                stacked: true,
                toolbar: {
                  show: true
                },
                zoom: {
                  enabled: true
                }
              }
            }
          }
        ]
      }
    };
  },
  computed: {
    getSeries() {
      if (this.data.datasets.length > 1) {
        let series = [
          {
            name: this.data.datasets[0].label,
            data: this.data.datasets[0].data
          },
          {
            name: this.data.datasets[1].label,
            data: this.data.datasets[1].data
          },
          {
            name: this.data.datasets[2].label,
            data: this.data.datasets[2].data
          }
        ];
        return series;
      } else {
        let series = [
          {
            name: this.data.datasets[0].label,
            data: this.data.datasets[0].data
          }
        ];

        return series;
      }
    }
  },
  mounted() {}
};
</script>

<style>
@keyframes rotate {
  to {
    transform: rotate(1turn);
  }
}

#containerChart {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
}

.titleGraph {
  color: #424242;
  font-size: 22px;
  font-family: sans-serif;
}
#cardContainer {
  height: 350px;
}
</style>



// WEBPACK FOOTER //
// src/components/charts/ApexChartVerticalBar.vue